<template>
    <div class="page article-detail">
        <article-detail-skeleton v-if="loading" style="margin-bottom: 100vh"></article-detail-skeleton>

        <div class="article-detail-box">
            <h3 class="article-detail-title">{{ article.title }}</h3>
            <div class="clear" style="margin-top: 15px"></div>

            <div>

                <div class="article-detail-content">
                    <div class="rich_media_inner" v-html="article.content"></div>
                </div>
            </div>
        </div>

        <div class="line"></div>

        <van-overlay :show="showShareDialog" @click="showShareDialog = false">
            <div class="share-box">
                <div class="block">请点击 “...”，再点击发送给朋友 | <span>知道啦</span></div>
                <div class="share-box-bottom">
                    <img src="/static/bytx/detail_forward_2_img.png" alt="" />
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import articleDetailSkeleton from '@/skeleton/articleDetailSkeleton'
import videojs from "video.js";
import {LocationHref} from '@/util/common'

export default {
    name: 'article-detail',
    components: {
        'article-detail-skeleton': articleDetailSkeleton,
    },
    data() {
        return {
            id: 0,
            value: '',
            active: '',
            category_id: 0,
            category_child_id: 0,
            banners: [],
            categories: [],
            categories_child: [],
            recommend: [],
            list: [],
            column: [],
            article: {},
            loading: true,
            share_data: {},
            showShareDialog: false,
            htmlUrl: '',
            isShow: false,
            status: '',
            to_user_id: 0,
            user_id: 0,
            showAction: false,
            showActionMeme: false,
            showActionScribe: false,
            is_manager: true
        }
    },
    methods: {
        goWechat() {
            LocationHref('https://work.weixin.qq.com/kfid/kfc80e2e65a20c7e4b8')
        },
        showDialog() {
            this.$refs.Refconsult.overlayShow = true
        },
        fetch(scene) {
            if (scene === 'homepage') {
                Interface.getData('get', Interface.subject.index+this.id).then(res => {
                    if (res.code == 0) {
                        this.topic = res.data

                        this.topic.topics.forEach(val => {

                            if (val.id == this.$route.params.topic){

                                val.content.forEach((item,i)=>{
                                    if (i == this.$route.params.i){
                                        this.article = {
                                            title: item.title,
                                            content: item.content,
                                        }
                                        Interface.getShareInfo(this, item.title+"-博医同行", item.cover_img, "")
                                    }
                                })
                            }
                        })
                        this.loading = false
                    }
                })
            }
        },
        changeCategory() {
            this.fetch('article')
        },
        favorite() {
            Interface.getData('get', Interface.article.favorite + '/' + this.id).then(res => {
                if (res.code == 0) {
                    this.article.isFavorite = !this.article.isFavorite
                }
            })
        },
        checkUserLogin() {
            this.userLoginCheck()
        },
        pointLikeComment(item) {
            Interface.getData('get', Interface.pointLikeComment + item.id).then(res => {
                if (res.code == 0) {
                    item.isLike = !item.isLike
                    if (item.isLike) {
                        item.like_count += 1
                    } else {
                        item.like_count -= 1
                    }
                }
            })
        },
        openShareData() {
            this.showShareDialog = true
        },
        setCurrentUrl: () => {
            let url = location.href.replace(/&wx=[-]{}/g, '')
            window.history.replaceState({}, document.title, url)
        }
    },
    created() {
        this.setCurrentUrl()
        this.id = this.$route.params.id
        this.fetch('homepage')
    }
}
</script>

<style lang="scss">
@import './article';
</style>



// WEBPACK FOOTER //
// src/views/subject/article.vue